"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { initAnalytics, trackPageViewed } from "@/lib/analytics";

const PAGE_NAME_MAP: Record<string, string> = {
  "/": "Home",
  "/apply-member": "Apply Member",
  "/privacy": "Privacy Policy",
  "/terms": "Terms of Service",
};

function getPageName(pathname: string): string {
  return PAGE_NAME_MAP[pathname] || pathname;
}

interface AnalyticsProviderProps {
  children: React.ReactNode;
}

export default function AnalyticsProvider({ children }: AnalyticsProviderProps) {
  const pathname = usePathname();

  // Initialize Mixpanel once on mount
  useEffect(() => {
    initAnalytics();
  }, []);

  // Track page views on route change
  useEffect(() => {
    trackPageViewed(getPageName(pathname), pathname);
  }, [pathname]);

  return <>{children}</>;
}
